import { apiClient, API_BASE_URL } from './apiClient';

const BASE = `${API_BASE_URL}/api/collaborators`;

const toQuery = (params = {}) => {
  const entries = Object.entries(params).filter(
    ([, value]) => value !== undefined && value !== null && value !== ''
  );
  if (!entries.length) return '';
  return `?${new URLSearchParams(entries.map(([k, v]) => [k, String(v)])).toString()}`;
};

export const getCollaborators = async (params = {}) => {
  return apiClient(`${BASE}/${toQuery(params)}`);
};

export const getCollaborator = async (collaboratorId) => {
  return apiClient(`${BASE}/${collaboratorId}`);
};

export const createCollaborator = async (payload) => {
  return apiClient(`${BASE}/`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
};

export const updateCollaborator = async (collaboratorId, payload) => {
  return apiClient(`${BASE}/${collaboratorId}`, {
    method: 'PUT',
    body: JSON.stringify(payload),
  });
};

export const deleteCollaborator = async (collaboratorId) => {
  return apiClient(`${BASE}/${collaboratorId}`, {
    method: 'DELETE',
  });
};
